var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div style=\"background: #fff;\" ng-class=\"{'intro-steps': intro_started, 'first-form-steps': first_form_started }\" class=\"global_wrapper\"><navbar></navbar><div style=\"background: #fff;\"><subnavbar></subnavbar><flash-message id=\"beta\" name=\"beta\"></flash-message><div id=\"preloader2\" ng-if=\"show_spinner\"><img" + (jade.attr("src", require('./../../images/6.gif'), true, true)) + " width=\"114\" alt=\"\"><p>Loading...</p></div><div ui-view=\"\" ng-if=\"!show_spinner\"></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/dashboard.jade
// module id = 708
// module chunks = 0